import { render } from "./matching-list-desktop.vue?vue&type=template&id=2c18f99e&scoped=true&ts=true"
import script from "./matching-list-desktop.vue?vue&type=script&lang=ts"
export * from "./matching-list-desktop.vue?vue&type=script&lang=ts"

import "./matching-list-desktop.vue?vue&type=style&index=0&id=2c18f99e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c18f99e"]])

export default __exports__